
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifting",
      function () {
        return require("private-next-pages/lifting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifting"])
      });
    }
  